import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showTrackOrderdetails: false,
  showParticipantsOverlay: false,
  addressValidationCount: 0,
  shippingAddress: {},
  isSuggestedAddressSelected: false,
  isShippingFormModified: false,
  showRecentOrderBanner: false,
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setShowTrackOrderdetails: (state, action) => {
      state.showTrackOrderdetails = action.payload;
    },
    setShowParticipantsOverlay: (state, action) => {
      state.showParticipantsOverlay = action.payload;
    },
    setAddressValidationCount: (state) => {
      state.addressValidationCount += 1;
    },
    resetAddressValidationCount: (state) => {
      state.addressValidationCount = 0;
    },
    setCurrentShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
    },
    resetCurrentShippingAddress: (state) => {
      state.shippingAddress = {};
    },
    setIsSuggestedAddressSelected: (state, action) => {
      state.isSuggestedAddressSelected = action.payload;
    },
    setIsShippingFormModified: (state, action) => {
      state.isShippingFormModified = action.payload;
    },
    setShowRecentOrderBanner: (state, action) => {
      state.showRecentOrderBanner = action.payload;
    },
  },
});

/** Action creators are generated for each case reducer function */
export const {
  setShowTrackOrderdetails,
  setShowParticipantsOverlay,
  setAddressValidationCount,
  resetAddressValidationCount,
  setCurrentShippingAddress,
  resetCurrentShippingAddress,
  setIsSuggestedAddressSelected,
  setIsShippingFormModified,
  setShowRecentOrderBanner,
} = orderSlice.actions;

export default orderSlice.reducer;
